import {
  Box as ManBox,
  // Button as ManButton,
  // Group as ManGroup,
  // Divider as ManDivider,
  // Text,
} from "@mantine/core"
// import { AiOutlinePlus } from "react-icons/ai"
import { useDisclosure } from "@mantine/hooks"
import { useCallback, useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { useHistory } from "react-router-dom" 
import styles from "../../styles/Callsheets.module.css";
import btnStyles from "../../styles/Button.module.css";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AddUserModal from "./AddUserModal"
import { formSchema } from "./addUserFormValidation"
import axios from "axios"
import UserTable from "./UserTable"
import { toast } from "react-hot-toast"
import UserDeleteConfirmAlert from "./UserDeleteConfirmAlert"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import EditUserModal from "./EditUserModal"
import TopBox from "../../components/TopBox"

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.error ||
  error?.response?.data?.detail ||
  error?.response?.data?.message ||
  error?.message ||
  fallback

const ManageUsers = () => {
  const history = useHistory();
  const currentUser = useCurrentUser()
  const [opened, { open, close }] = useDisclosure(false)

  const [
    userDeleteAlertOpened,
    { open: userDeleteAlertOpen, close: userDeleteAlertClose },
  ] = useDisclosure(false)
  const [
    userEditFormOpened,
    { open: userEditFormOpen, close: userEditFormClose },
  ] = useDisclosure(false)
  const [totalUsersCount, setTotalUsersCount] = useState(0)
  const [users, setUsers] = useState(0)
  const [userToBeDeleted, setUserToBeDeleted] = useState(null)
  const [userToBeEditted, setUserToBeEditted] = useState(null)
  const [isDeleteUserSubmitting, setIsDeleteUserSubmitting] = useState(null)

  const clickInfo = () => {
    /* Function to open the Info */
    history.push(
      `/${localStorage.getItem(
              "projectSlug"
            )}/manageinfo`
    );
  };

  const {
    control,
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: zodResolver(formSchema),
  })

  const handleOpenAddUserModal = useCallback(() => {
    open()
  }, [open])

  const handleCloseAddUserModal = useCallback(() => {
    reset()
    close()
  }, [close, reset])

  const onSubmit = async (data) => {
    const {
      callTimeUserName,
      character,
      email,
      firstName,
      lastName,
      groups,
      phoneNumber,
      username,
    } = data

    const body = {
      username,
      first_name: firstName,
      last_name: lastName,
      email,
      groups: [groups],
      phone_number: phoneNumber,
      ...(callTimeUserName ? { call_time_username: callTimeUserName } : {}),
      ...(character ? { cast_character: Number(character) } : {}),
    }

    try {
      const response = await axios.post(
        `/${localStorage.getItem("projectSlug")}/users/`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      )
      const result = response?.data ?? response
      if (result?.success === false || result?.status === false) {
        throw result?.error || new Error("Failed to add user")
      }
      toast.success("User Added Successfully! ")
      reset()
      handleCloseAddUserModal()
      fetchUsers()
    } catch (error) {
      console.log("User creation failed: ", error.response)
      toast.error(getErrorMessage(error, "Failed to add user!"))
      if (error?.response?.data?.username?.length > 0) {
        return toast.error(error.response.data.username[0])
      } else {
        return toast.error("Failed to add user!")
      }
    }
  }

  const fetchUsers = async () => {
    try {
      const { data } = await axios.get(
        `/${localStorage.getItem("projectSlug")}/users/`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      )
      setTotalUsersCount(data.count)
      setUsers(data.results)
      // console.log(data.results)
    } catch (error) {
      console.log("Failed to fetch users: ", error)
    }
  }

  useEffect(() => {
    fetchUsers()
  }, [])

  const handleUserDeleteAlertOpen = (row) => {
    setUserToBeDeleted(row)
    userDeleteAlertOpen()
  }

  const handleUserDeleteAlertClose = useCallback(() => {
    setUserToBeDeleted(null)
    userDeleteAlertClose()
  }, [userDeleteAlertClose])

  const handleUserDeleteSubmit = async () => {
    const userIdToBeDeleted = userToBeDeleted.original.id
    try {
      setIsDeleteUserSubmitting(true)
      await axios.delete(
        `/${localStorage.getItem("projectSlug")}/users/${userIdToBeDeleted}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          withCredentials: true,
        }
      )
      toast.success("User deleted")
      userDeleteAlertClose()
      setUserToBeDeleted(null)
      fetchUsers()
    } catch (error) {
      toast.error("User deletion failed")
    } finally {
      setIsDeleteUserSubmitting(false)
    }
  }

  const handleUserEditFormOpen = useCallback(
    (row) => {
      setUserToBeEditted(row)
      userEditFormOpen()
    },
    [userEditFormOpen]
  )

  const handleCloseEditUserModal = () => {
    setUserToBeEditted(null)
    userEditFormClose()
  }

  return (
    <>
    <TopBox title="Manage Users" />
    {/* back */}
    <Row>
    <Col xs={4}>
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} py-0 mt-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
    </Col>
    </Row>
    <h5 className={`text-center py-1 mt-3 ${styles.SubTitle }`}>
             REGISTER AND MANAGE USERS</h5> 
    {/* info but and add user button*/}
    <Row className="my-2">
    <Col xs={6}>
      <Button
        className={`py-0 px-2 px-md-5 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => clickInfo()}
      >
        MANAGE USERS INFO
      </Button>
    </Col>
    <Col className="" xs={6}>
    <Button
        className={`py-0 float-right px-3 px-md-5 ${btnStyles.Order} ${btnStyles.ButtonB}`}
       onClick={handleOpenAddUserModal} 
      >
        <i className="fa fa-plus mr-3 py-0"></i> ADD USER
      </Button>
    </Col>
    </Row>
      {/* add user modal */}
      <AddUserModal
        handleCloseAddUserModal={handleCloseAddUserModal}
        opened={opened}
        handleSubmit={handleSubmit}
        register={register}
        errors={errors}
        isSubmitting={isSubmitting}
        onSubmit={onSubmit}
        control={control}
        setValue={setValue}
        userType={currentUser?.groups[0]?.name}
      />
      <EditUserModal
        initialData={userToBeEditted}
        userType={currentUser?.groups[0]?.name}
        userEditFormOpened={userEditFormOpened}
        handleCloseEditUserModal={handleCloseEditUserModal}
        fetchUsers={fetchUsers}
      />

      <UserDeleteConfirmAlert
        handleUserDeleteAlertClose={handleUserDeleteAlertClose}
        userDeleteAlertOpened={userDeleteAlertOpened}
        handleUserDeleteSubmit={handleUserDeleteSubmit}
        isDeleteUserSubmitting={isDeleteUserSubmitting}
      />

      <ManBox
        sx={(theme) => ({
          width: "100%",
          minHeight: "100%",
          paddingLeft: "3rem",
          paddingRight: "3rem",
          paddingTop: "1rem",
          border: "cyan",
          "@media (max-width: 700px)": {
            paddingLeft: "1rem",
            paddingRight: "1rem",
          },
        })}
      >

        <ManBox sx={{ width: "100%", marginTop: "1rem" }}>
          {users.length <= 0 && <div>Loading...</div>}
          {users.length > 0 &&
            currentUser &&
            currentUser?.groups?.length > 0 && (
              <UserTable
                totalUsersCount={totalUsersCount}
                users={users}
                handleUserDeleteAlertOpen={handleUserDeleteAlertOpen}
                currentUser={currentUser}
                handleUserEditFormOpen={handleUserEditFormOpen}
              />
            )}
        </ManBox>
      </ManBox>
    </>
  )
}
export default ManageUsers
